import { render, staticRenderFns } from "./PagedLoading.vue?vue&type=template&id=4eac8ef7&"
import script from "./PagedLoading.vue?vue&type=script&lang=js&"
export * from "./PagedLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports